import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/workspace/src/layouts/default.vue").then(m => m.default || m))
}